import WebView from "./WebViewPlugin";
import Fetcher from "./FetcherPlugin";
import FileExplorer from "./FileExplorerPlugin";
import Notifier from "./NotifierPlugin";


export {FileExplorerEntry} from "./FileExplorerPlugin";

export default {
    id:"cordovaplugins",
    name:"cordova plugins",
    docs:[
        WebView,
        Fetcher,
        FileExplorer,
        Notifier,
    ],
}
